import React from 'react';
import PropTypes from 'prop-types';
import ConnectedIntelligentReview from './ConnectedIntelligentReview';

const IntelligentReviewRouting = () => <ConnectedIntelligentReview />;

IntelligentReviewRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default IntelligentReviewRouting;
